import {TextNode as SubstanceTextNode} from 'substance'

class UnsupportedTextNode extends SubstanceTextNode {}

UnsupportedTextNode.type = 'unsupportedtextnode'
UnsupportedTextNode.define({
    "originalType": {type: 'string'}
})

export {UnsupportedTextNode}
